<script setup>
import { computed } from 'vue';
import ViewRowDefault from 'module/footer/ViewRowDefault.vue';
import InstagramIcon from 'module/icon/files/social-icons/instagram.svg';
import FacebookIcon from 'module/icon/files/social-icons/facebook.svg';
import LinkedinIcon from 'module/icon/files/social-icons/linkedin.svg';
import PinterestIcon from 'module/icon/files/social-icons/pinterest.svg';
import TiktokIcon from 'module/icon/files/social-icons/tiktok.svg';
import YoutubeIcon from 'module/icon/files/social-icons/youtube.svg';
import NorikaGroupClaim from '../../../public/assets/images/footer/norika-group.svg';

const props = defineProps({
    modifier: String,
    showSocialList: Boolean,
});

const currentYear = new Date().getFullYear();

const footerClass = computed(() => ({
    'm-footer': true,
    [`m-footer--${props.modifier}`]: props.modifier,
}));

const footerWrapClass = computed(() => ({
    'm-footer__wrap': true,
    [`m-footer__wrap--${props.modifier}`]: props.modifier,
}));

const displayViewRow = computed(() => props.modifier !== 'small' && props.modifier !== 'centered');
</script>

<template>
    <footer :class="footerClass">
        <div :class="footerWrapClass">
            <ViewRowDefault v-if="displayViewRow" />

            <div
                v-if="showSocialList"
                class="m-footer__socialMediaContainer"
            >
                <ul class="m-footer__socialList">
                    <li class="m-footer__socialItem">
                        <a
                            aria-label="Instagram"
                            class="m-footer__socialLinks"
                            href="https://www.instagram.com/karriere.at/"
                        >
                            <InstagramIcon
                                class="m-footer__socialIcon m-footer__socialIcon--instagram"
                            />
                        </a>
                    </li>
                    <li class="m-footer__socialItem">
                        <a
                            aria-label="LinkedIn"
                            class="m-footer__socialLinks"
                            href="https://www.linkedin.com/company/karriere-at/"
                        >
                            <LinkedinIcon
                                class="m-footer__socialIcon m-footer__socialIcon--linkedin"
                            />
                        </a>
                    </li>
                    <li class="m-footer__socialItem">
                        <a
                            aria-label="Facebook"
                            class="m-footer__socialLinks"
                            href="https://www.facebook.com/karriere.at"
                        >
                            <FacebookIcon
                                class="m-footer__socialIcon m-footer__socialIcon--facebook"
                            />
                        </a>
                    </li>
                    <li class="m-footer__socialItem">
                        <a
                            aria-label="TikTok"
                            class="m-footer__socialLinks"
                            href="https://www.tiktok.com/@karriere.at"
                        >
                            <TiktokIcon
                                class="m-footer__socialIcon m-footer__socialIcon--tiktok"
                            />
                        </a>
                    </li>
                    <li class="m-footer__socialItem">
                        <a
                            aria-label="YouTube"
                            class="m-footer__socialLinks"
                            href="https://www.youtube.com/user/karriereatchannel"
                        >
                            <YoutubeIcon
                                class="m-footer__socialIcon m-footer__socialIcon--youtube"
                            />
                        </a>
                    </li>
                    <li class="m-footer__socialItem">
                        <a
                            aria-label="Pinterest"
                            class="m-footer__socialLinks"
                            href="https://www.pinterest.at/karriereat/"
                        >
                            <PinterestIcon
                                class="m-footer__socialIcon m-footer__socialIcon--pinterest"
                            />
                        </a>
                    </li>
                </ul>
            </div>

            <div class="m-footer__sublineContainer {{ $modifier ? 'm-footer__sublineContainer--' . $modifier : '' }}">
                <div class="m-footer__subline {{ $modifier ? 'm-footer__subline--' . $modifier : '' }}">
                    <ul class="m-footer__sublineLinklist">
                        <li class="m-footer__sublineItem">
                            <a
                                class="m-footer__sublineLink"
                                href="/lp/faqs"
                            >Häufige Fragen</a>
                        </li>
                        <li class="m-footer__sublineItem">
                            <a
                                class="m-footer__sublineLink"
                                href="/impressum"
                            >Impressum & Kontakt</a>
                        </li>
                        <li class="m-footer__sublineItem">
                            <a
                                class="m-footer__sublineLink"
                                href="/agb-bewerber"
                            >AGB</a>
                        </li>
                    </ul>

                    <ul class="m-footer__sublineLinklist">
                        <li class="m-footer__sublineItem">
                            <a
                                class="m-footer__sublineLink"
                                href="/datenschutzerklaerung"
                            >Datenschutz</a>
                        </li>
                        <li class="m-footer__sublineItem">
                            <a
                                class="m-footer__sublineLink"
                                href="/barrierefreiheit"
                            >Barrierefreiheit</a>
                        </li>
                        <li class="m-footer__sublineItem">
                            <a
                                class="m-footer__sublineLink"
                                href="/code-of-conduct"
                            >Code of Conduct</a>
                        </li>
                        <li
                            class="m-footer__sublineItem m-footer__sublineCopyright"
                            :class="modifier ? `m-footer__sublineCopyright--${modifier}` : ''"
                        >
                            &copy; {{ currentYear }}
                            <a
                                href="/"
                                class="m-footer__sublineLink"
                            >karriere.at</a> GmbH
                        </li>
                    </ul>
                </div>
                <a
                    aria-label="Norika Group Logo"
                    class="m-footer__sublineItem m-footer__groupLogoLink"
                    :class="modifier ? `m-footer__groupLogoLink--${modifier}` : ''"
                    href="https://norika.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <NorikaGroupClaim class="m-footer__groupLogo" />
                </a>
            </div>
        </div>
    </footer>
</template>

<style lang="scss">
@use "styles";
</style>
